export default {
  namespaced: true,
  state: {
    timeSpent: null,
    startedAt: null,
    numberOfAttempts: 0,
    finishedAt: null
  },
  getters: {},
  mutations: {
    reset(state, payload) {
      // @f: mission-initialize 5
      state.timeSpent = payload?.timeSpent ? payload?.timeSpent : 0;
      state.startedAt = payload?.startedAt
        ? payload?.startedAt
        : new Date().toISOString().replace('Z', '+0000');
      state.finishedAt = payload?.finishedAt ? payload?.finishedAt : null;
      state.numberOfAttempts = payload?.numberOfAttempts
        ? payload?.numberOfAttempts
        : 1;
    },
    finish(state) {
      // @f: mission-initialize 6
      const finishedAt = new Date().toISOString().replace('Z', '+0000');
      state.finishedAt = finishedAt;
      const diff =
        new Date(state.startedAt).getTime() - new Date(finishedAt).getTime();
      state.timeSpent = state.timeSpent + Math.abs(diff / 1000);
    },
    numberOfAttemptsIncrease(state) {
      state.numberOfAttempts = state.numberOfAttempts + 1;
    }
  },
  actions: {
    /**
     * @f: mission-initialize 4 = init the mission.
     * It gets from the tutorialState if its not finished , or it resets.
     */
    initialize({ commit, rootState, rootGetters }) {
      const tutorialState = rootState.workspace.session.tutorial.tutorialState;
      const showingPage = rootGetters['workspace/session/showingPage'];
      const solutions = rootState.workspace.session.user.solutions.sort(
        (s1, s2) => s2.pageNumber - s1.pageNumber
      );
      const isFinished = !!solutions.find(
        (solution) => solution.pageId === showingPage.pageId
      );
      const nextSolvePageNumber = solutions.length
        ? solutions[0].pageNumber + 1
        : 1;

      const lastSolvedPageNumber = tutorialState.lastPageStats.completed
        ? tutorialState.currentPage
        : tutorialState.currentPage + 1;

      // is the next mission.
      if (nextSolvePageNumber !== showingPage.pageNumber) return;

      if (
        // same page
        tutorialState &&
        lastSolvedPageNumber === showingPage.pageNumber &&
        !isFinished &&
        tutorialState.lastPageStats.numberOfAttempts
      )
        commit('reset', tutorialState.lastPageStats);
      else commit('reset');
    },
    finish({ commit }) {
      return new Promise((resolve, reject) => {
        commit('finish');
        setTimeout(() => {
          resolve(true);
        }, 250);
      });
    }
  }
};
